export const sfNames = {
  id: 'id',
  name: 'name',
  personId: 'personId',
  emailAddress: 'emailAddress',
  disabled: 'disabled',
  latestActivity: 'latestActivity',
  userType: 'userType',
  mainUserGroup: 'mainUserGroup',
  currentUserGroup: 'currentUserGroup',
  unit: 'unit',
  location: 'location',
  language: 'language',
  alternativeIds: 'alternativeIds',
  accessRole: 'accessRole'
};

export const sfParameters = {
  personId: 'personId'
};
